import {Injectable} from '@angular/core';

/**
 * Math service
 */
@Injectable({
  providedIn: 'root'
})
export class MathService {
  /**
   * Returns the rounded value of num to specified precision
   */
  static roundTo(num: number, precision: number = 0): number {
    const factor = 10 ** precision;
    return Math.round(num * factor) / factor;
  }
}
